import React from "react";

/**
 * User Pagination Component
 * Displays pagination controls for rows per page selection
 */
const UserPagination = ({
  total,
  rowsPerPage,
  handleRowsPerPageChange,
  showingDropdownRef,
  showingDropdownOpen,
  setShowingDropdownOpen,
}) => {
  return (
    <div className="filter-invoice-right">
      <div className="filter-inner showing-result">
        <label>Showing</label>
        <div
          ref={showingDropdownRef}
          className="select-modal-mainM custom-dropdown-user-new-outer"
        >
          <div
            className="selected-option custom-dropdown-user-new"
            onClick={() => setShowingDropdownOpen(!showingDropdownOpen)}
            role="button"
            tabIndex={0}
            aria-label="Select rows per page"
            aria-expanded={showingDropdownOpen}
            aria-haspopup="listbox"
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                setShowingDropdownOpen(!showingDropdownOpen);
              }
            }}
          >
            {total < 10 ? total.toString() : rowsPerPage.toString()}
          </div>
          {showingDropdownOpen && (
            <div className="custom-dropdown-new" role="listbox">
              <ul className="showing-options-list">
                {total >= 10 && (
                  <li
                    className={rowsPerPage === 10 ? "selected-item" : ""}
                    role="option"
                    aria-selected={rowsPerPage === 10}
                    onClick={() => {
                      handleRowsPerPageChange({ target: { value: 10 } });
                      setShowingDropdownOpen(false);
                    }}
                  >
                    10
                  </li>
                )}
                {total >= 20 && (
                  <li
                    className={rowsPerPage === 20 ? "selected-item" : ""}
                    role="option"
                    aria-selected={rowsPerPage === 20}
                    onClick={() => {
                      handleRowsPerPageChange({ target: { value: 20 } });
                      setShowingDropdownOpen(false);
                    }}
                  >
                    20
                  </li>
                )}
                {total >= 30 && (
                  <li
                    className={rowsPerPage === 30 ? "selected-item" : ""}
                    role="option"
                    aria-selected={rowsPerPage === 30}
                    onClick={() => {
                      handleRowsPerPageChange({ target: { value: 30 } });
                      setShowingDropdownOpen(false);
                    }}
                  >
                    30
                  </li>
                )}
                {total >= 40 && (
                  <li
                    className={rowsPerPage === 40 ? "selected-item" : ""}
                    role="option"
                    aria-selected={rowsPerPage === 40}
                    onClick={() => {
                      handleRowsPerPageChange({ target: { value: 40 } });
                      setShowingDropdownOpen(false);
                    }}
                  >
                    40
                  </li>
                )}
                {total > 10 && (
                  <li
                    className={total > 10 && rowsPerPage === total ? "selected-item" : ""}
                    role="option"
                    aria-selected={rowsPerPage === total}
                    onClick={() => {
                      handleRowsPerPageChange({ target: { value: total } });
                      setShowingDropdownOpen(false);
                    }}
                  >
                    ALL
                  </li>
                )}
                {total < 10 && (
                  <li
                    className={total < 10 ? "selected-item" : ""}
                    role="option"
                    aria-selected={rowsPerPage === total}
                    onClick={() => {
                      handleRowsPerPageChange({ target: { value: total } });
                      setShowingDropdownOpen(false);
                    }}
                  >
                    {total}
                  </li>
                )}
              </ul>
            </div>
          )}
        </div>
        <label>of {total} Results</label>
      </div>
    </div>
  );
};

export default UserPagination;

